<template>
    <c-modal
        v-model="isVisible"
        dialog-class="scopes-update-wrapper"
        title="Update your TikTok Shop"
        hide-footer
        @closed="onSkip"
    >
        <div class="content text-center">
            <p>Due to recent changes in your TikTok Shop account, you need to reconnect your store.</p>
            <template v-for="session of sessions">
                <div v-if="session.shop" :key="session.shop">
                    <p class="mb-0 mt-3">
                        <strong>{{ session.shopName || session.shop }}</strong>
                    </p>
                    <loader-btn
                        loading-text="Loading..."
                        :loading="reconnectingShop === session.shop"
                        variant="primary"
                        class="mx-auto my-3"
                        @click="reconnect(session.shop)"
                    >
                        Reconnect my store
                    </loader-btn>
                </div>
            </template>

            <a class="skip-link" href="#" @click="onSkip">Skip for now</a>

            <p class="legend">
                If you do not reconnect, Customily won't work properly on your TikTok Shop, and new orders won't get
                personalization links.
            </p>
        </div>
    </c-modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import CModal from '@/components/CModal.vue';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';
import { getTikTokReconnectUrl } from '@/api/storesApp/tiktok';

withDefaults(defineProps<{ sessions?: { shop: string; shopName?: string }[] }>(), { sessions: () => [] });
const emit = defineEmits<{ (event: 'close'): void }>();

const isVisible = ref(true);
const reconnectingShop = ref('');

const onSkip = () => emit('close');

const reconnect = async (shop: string) => {
    reconnectingShop.value = shop;
    try {
        window.open(await getTikTokReconnectUrl(shop), '_parent');
    } catch (error) {
        console.error('Error during TikTok link redirection:', error);
    } finally {
        reconnectingShop.value = '';
    }
};
</script>

<style scoped lang="scss">
::v-deep .scopes-update-wrapper {
    .modal-header {
        text-align: center;
        background: linear-gradient(141deg, #849dd8 15%, #8bc4d3 75%);
        color: #fff;
    }
    .skip-link {
        color: unset;
        text-decoration: underline;
        font-weight: bold;
    }
    .legend {
        font-size: 12px;
        margin-top: 1rem;
        margin-bottom: 0;
    }
}
</style>
